/**
 * Discover API Service
 *
 * Mangas entdecken, die noch nicht Teil der eigenen Sammlung sind.
 *
 * Endpoints:
 * GET /discover?cursor=&limit=&sort= - Discover-Feed laden
 */

import { get } from '../client';

export const SORT_OPTIONS = [
  { value: 'NEWEST', label: 'Neueste zuerst' },
  { value: 'POPULAR', label: 'Beliebt' },
  { value: 'UPCOMING', label: 'Bald erhältlich' },
  { value: 'RECOMMENDED', label: 'Für dich empfohlen' },
];

/**
 * Discover-Feed laden
 * @param {object} options - { cursor?, limit?, sort? }
 * @returns {Promise<{success: boolean, data?: {items: DiscoverItem[], next_cursor: number|null}, error?: object}>}
 *
 * sort: NEWEST | POPULAR | UPCOMING | RECOMMENDED (Default: NEWEST)
 */
export const getDiscoverFeed = async (options = {}) => {
  const params = {};
  if (options.cursor !== undefined && options.cursor !== null) params.cursor = options.cursor;
  params.limit = options.limit ?? 50;
  if (options.sort) params.sort = options.sort;
  return get('/discover', params);
};

// ============================================================================
// TYPES (JSDoc)
// ============================================================================

/**
 * @typedef {object} DiscoverItem
 * @property {number} manga_id
 * @property {string} title
 * @property {string} publisher
 * @property {string} status
 * @property {string} cover_media_key
 * @property {number} band_count
 * @property {boolean} is_new
 * @property {boolean} matches_interests
 */
